import React from "react";
import SidebarLayout from "../../../layouts/SidebarLayout";

export default function Promotion() {
  return <SidebarLayout title="Promotion">Promotion</SidebarLayout>;
}
